export class SecurityQuestions {

    constructor() {
        this.question1 = '';
        this.question2 = '';
        this.question3 = '';
        this.question4 = '';
    }
    
    question1: string;
    question2: string;
    question3: string;
    question4: string;
    answer1: string = '';
    answer2: string = '';
    answer3: string = '';
    answer4: string = '';
    verificationCode: string = '';
    userId: number = 0;
}